import { useParams } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'
import { TaskDetailPageDocument } from 'generated/resources/graphql'
import compact from 'lodash/compact'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import { TaskElementContent } from 'modules/tasks/components/TaskElement/TaskElementContent'
import { useTaskDetails } from 'modules/tasks/components/TaskElement/useTaskDetail'
import { TaskIdentifier } from 'modules/tasks/lib/task'

const TaskDetailPage = () => {
  const { taskId } = useParams()
  const { company } = useCurrentSession()

  // TODO: consider merging this with the page query
  const {
    task,
    loading: isLoadingTask,
    canSeePersonalInfo,
    canEditPersonalInfo,
    canEmployeeManageAnyEmployeeFolder,
    referenceContract,
    hasDevTimeTrackingWorkableDaysDefinition,
    hasTimeTrackingAnnualisationDailyValue,
    jobCatalogContextlessPolicies,
    hasPayrollBundle,
    contractContextlessPolicies,
    customFieldsContextlessPolicies,
  } = useTaskDetails({
    companyId: company.id,
    ids: [Number(taskId)],
    identifier: TaskIdentifier.Workflow,
  }) // onboarding tasks should always be related to flows

  const { data, loading } = useQuery(TaskDetailPageDocument, {
    variables: {
      taskId: Number(taskId),
      usageGroupSlugs: ['employees-questions'],
    },
  })

  const customResourceFieldsData =
    compact(data?.customFields.resourceFieldsConnection.edges.map((edge) => edge.node)) ?? []

  const customValuesData =
    data?.tasks.tasksConnection.edges[0]?.node?.affecteesConnection.edges[0]?.node?.employee
      ?.values ?? []

  return (
    <ResponsivePage.Body loading={isLoadingTask || loading} error={null} authorized={!!task}>
      <Box flexDirection="column" gap="s16" flexGrow>
        {task && (
          <TaskElementContent
            task={task}
            canSeePersonalInfo={canSeePersonalInfo}
            canEditPersonalInfo={canEditPersonalInfo}
            canEmployeeManageAnyEmployeeFolder={canEmployeeManageAnyEmployeeFolder}
            customResourceFieldsData={customResourceFieldsData}
            customValuesData={customValuesData}
            referenceContract={referenceContract}
            hasDevTimeTrackingWorkableDaysDefinition={hasDevTimeTrackingWorkableDaysDefinition}
            hasTimeTrackingAnnualisationDailyValue={hasTimeTrackingAnnualisationDailyValue}
            jobCatalogContextlessPolicies={jobCatalogContextlessPolicies}
            hasPayrollBundle={hasPayrollBundle}
            contractContextlessPolicies={contractContextlessPolicies}
            customFieldsContextlessPolicies={customFieldsContextlessPolicies}
          />
        )}
      </Box>
    </ResponsivePage.Body>
  )
}

export default TaskDetailPage
